export enum LogoutStatus {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed',
}

export interface LogoutState {
  status: LogoutStatus;
  idpLogoutUrl?: string;
}
